<template>
  <div>
    <el-drawer @reload="$reloadHandle"
               title="审核" size="30%"
               :before-close="handleClose"
               :visible.sync="drawer"
               direction="rtl"
               :modal-append-to-body="true"
               custom-class="demo-drawer"
               ref="drawer"
    >

      <div class="demo-drawer__content">
        <el-form :model="formData">
          <el-form-item label="入库仓" name="remark" :rules="{required: true}">
            <el-select v-model="formData.inWarehouseId" placeholder="请选择" style="line-height: 36px;">
              <el-option v-for="item in warehouseList" :value="item.id" :key="item.id" :label="item.warehouseName"/>
            </el-select>
          </el-form-item>
        </el-form>
        <div class="demo-drawer__footer" style="position: absolute;
    bottom: 5px;
    right: 5px;">
          <el-button @click="cancelForm">取 消</el-button>
          <el-button type="primary" @click="close">
            确 定
          </el-button>
        </div>
      </div>
    </el-drawer>

  </div>
</template>
<script>
// import orderPop from './orderDialog.vue'

import api from "@/api/projectApi";

export default {
  name: 'partsReturnAuditDialog',
  props: ['multi', 'dataId',],
  created() {
    this.formData.id = this.dataId
  },
  mounted() {
    this.getInWarehouseData()
  },
  data() {
    return {
      formData: {
        remark: null,
        id: null,
        type: null,
        inWarehouseId: null
      },
      drawer: true,
      warehouseList: [],
    }
  },
  methods: {
    // 加载入库仓数据
    getInWarehouseData() {
      this.$http({
        url: api.spPartsReturnHeader.getInWarehouseDataUrl,
        method: 'post',
        data: this.formData
      }).then(res => {
        // console.log(res.data.data)
        this.warehouseList = res.data.data.warehouseList
        this.formData.inWarehouseId = res.data.data.inWarehouseId
      })
    },


    close() {
      if (!this.formData.inWarehouseId) {
        this.$message.error('请选择入库仓')
        return
      }

      this.$mask.open()
      this.$http({
        url: api.spPartsReturnHeader.auditDataUrl,
        method: 'post',
        data: this.formData
      }).then(res => {
        this.$message.success('操作成功')
        this.handleClose()
        this.$emit('goBackIndex')
        this.$mask.close()
      }).catch(e => {
        this.$message.error(e)
        console.log(e)
        this.$mask.close()
      })
    },


    confirm() {
      this.drawer = false;
      this.handleClose()
    },
    cancelForm() {
      this.handleClose()
    },
    handleClose() {
      this.visiable = false
      this.$emit('update:visiable', this.visiable)
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-drawer .el-drawer__body {
  padding: 0 16px;
  background-color: #fff;
  position: relative;
}

::v-deep .el-drawer .el-drawer__header {
  background-color: #fff;
}

::v-deep .el-drawer__container {
  position: relative;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  height: 100%;
  width: 100%;
  background: aliceblue;
  background-color: rgb(38 38 38 / 70%);
}

#containt .table-detail {
  border-collapse: collapse;
  font-size: 12px;
  border: 1px solid #ededed;
}

.btn {
  text-align: center;
}
</style>
